import { isGoNative } from "@/utils/isGoNative";
import useOverwolfInterop from "./useOverwolfInterop";

export const useCopyToClipboard = () => {
    const { isOnOverwolf, sendMessageToOW} = useOverwolfInterop();
    const copyToClipboard = (text: string) => {
        if (isOnOverwolf) {
            sendMessageToOW({ type: "de:copy-to-clipboard", payload: text });
        } else
            if (isGoNative()) {
                // @ts-ignore
                gonative.clipboard.set({ data: text }); // for app to copy to clipboard
            } else {
                navigator.clipboard.writeText(text);
            }
    };

    return { copyToClipboard };

};